export default __webpack_public_path__ + "static/media/Homies.e61391dd.JPG";